import Api from "../axios";

export const getActivePlans = async () => {
    console.log( Api.get(`/Game/GetActivePlans`),' Api.get(`/Game/GetActivePlans`)')
    return await Api.get(`/Game/GetActivePlans`)
};
